import { Box } from '@mui/material'
import { Alert, Text } from 'ui/baseComponents'
import MainContent from 'ui/templates/MainContent'
import CookieBanner from 'ui/components/CookieBanner/CookieBanner'
import ErrorBoundary from 'ui/components/ErrorBoundary'
import { Error, NotificationBar } from 'ui/components/Notifications'
import Loading from 'ui/components/Loading'
import MainNav from 'ui/components/MainNav'
import MainContentWrapper from 'ui/templates/MainContentWrapper'
import PageHeader from 'ui/templates/PageHeader'
import { useMemo, useState } from 'react'
import useOrgList from 'ui/hooks/useOrgList'
import { ORG_TABLE_LOADING_ERROR } from 'ui/screens/Organizations/consts'
import { colors } from 'theme/colors'
import OrganizationsTable from 'ui/screens/Organizations/OrganizationsTable'

const Organizations = () => {
  const STYLES = {
    outerWrapper: {
      paddingTop: '1rem',
      backgroundColor: colors.COOL[100],
    },
    innerWrapper: {
      padding: '1rem',
    },
    orgCount: {
      color: colors.GREY[700],
    },
    viewButton: {
      border: '1px solid !important',
    },
  }

  const [orgChangeError, setOrgChangeError] = useState(null)

  const { loading, error, data } = useOrgList()

  const orgList = useMemo(() => data?.orgList?.orgs || [], [data])

  return (
    <>
      <MainNav />

      <PageHeader
        title={
          <Text component="h1" variant="head42" data-cy="org-list-header">
            Organizations ({orgList.length})
          </Text>
        }
      />

      <MainContentWrapper>
        <ErrorBoundary>
          <Box sx={STYLES.outerWrapper}>
            <MainContent>
              <Box sx={STYLES.innerWrapper}>
                {error && (
                  <Alert severity="error">
                    <Text>{ORG_TABLE_LOADING_ERROR}</Text>
                  </Alert>
                )}
                {loading && <Loading />}
                {!loading && !error && (
                  <OrganizationsTable
                    orgList={orgList}
                    setOrgChangeError={setOrgChangeError}
                  />
                )}
              </Box>
            </MainContent>
          </Box>
        </ErrorBoundary>
      </MainContentWrapper>

      <CookieBanner />

      {orgChangeError && (
        <NotificationBar open={orgChangeError}>
          <Error message={orgChangeError} />
        </NotificationBar>
      )}
    </>
  )
}

export default Organizations
